"use client";

import { useState, useEffect } from "react";
import { FaUserCircle, FaBuilding } from "react-icons/fa";
import "./typeSelection.css";
import { use } from "react";
import {
  getIndustriesListApi,
  setUserTypeApi,
} from "../../services/authService";
import { handleApiError } from "../shared/utils";

export default function RoleSelectionPage() {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [showBusinessPopup, setShowBusinessPopup] = useState(false);
  const [businessFormData, setBusinessFormData] = useState({
    organization: "",
    website: "",
    industry: "",
  });
  const [businessFormErrors, setBusinessFormErrors] = useState({});

  //   const INDUSTRY_OPTIONS = [
  //     "Technology",
  //     "Healthcare",
  //     "Finance",
  //     "Education",
  //     "Manufacturing",
  //     "Retail",
  //     "Consulting",
  //     "Media & Entertainment",
  //     "Transportation",
  //     "Energy",
  //     "Real Estate",
  //     "Other",
  //   ];

  useEffect(() => {
    // getIndustriesListApiHandler();
  }, []);
  const [industries, setIndustries] = useState(null);
  const getIndustriesListApiHandler = async () => {
    try {
      const response = await getIndustriesListApi();
      setIndustries(response.data);
    } catch (error) {
      handleApiError(error, {
        showModal: false,
      });
    }
  };

  const handleRoleSelect = async (role) => {
    if (role === "business") {
      setShowBusinessPopup(true);
      return;
    }

    setIsLoading(role);
    try {
      let obj = {
        email: sessionStorage.getItem("email"),
        userType: "Individual User",
        // organization: businessFormData.organization,
        // website: businessFormData.website,
      };
      console.log("Set User Type Obj:", obj);

      const response = await setUserTypeApi(obj);
      console.log("Set User Type Response:", response);
      if (response.code === 200) {
        // redirect to the blank page from the api response
        window.location.href = response.data;
      }
    } catch (error) {
      handleApiError(error, { showModal: true });
    }
  };

  const handleBusinessFormChange = (e) => {
    const { name, value } = e.target;
    setBusinessFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (businessFormErrors[name]) {
      setBusinessFormErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateBusinessForm = () => {
    const errors = {};
    if (!businessFormData.organization.trim()) {
      errors.organization = "Organization is required";
    }
    if (!businessFormData.website.trim()) {
      errors.website = "Website is required";
    }

    return errors;
  };

  const handleBusinessFormSubmit = async (e) => {
    e.preventDefault();
    const errors = validateBusinessForm();

    if (Object.keys(errors).length > 0) {
      setBusinessFormErrors(errors);
      return;
    }

    setIsLoading("business");
    try {
      let obj = {
        email: sessionStorage.getItem("email"),
        userType: "Business User",
        organization: businessFormData.organization,
        website: businessFormData.website,
      };
      console.log("Set User Type Obj:", obj);

      const response = await setUserTypeApi(obj);
      console.log("Set User Type Response:", response);
      if (response.code === 200) {
        // redirect to the blank page from the api response
        window.location.href = response.data;
      }
    } catch (error) {
      handleApiError(error, { showModal: true });
    }
    // setTimeout(() => {
    //   console.log("Business form submitted:", businessFormData);
    //   setShowBusinessPopup(false);
    //   setBusinessFormData({ organization: "", website: "", industry: "" });
    // }, 600);
  };

  const handleClosePopup = () => {
    setShowBusinessPopup(false);
    setBusinessFormData({ organization: "", website: "", industry: "" });
    setBusinessFormErrors({});
  };

  return (
    <div className="tmw-role-container">
      <div className="tmw-role-background">
        <div className="tmw-role-gradient-blob"></div>
        <div className="tmw-role-gradient-blob-secondary"></div>
      </div>

      <main className="tmw-role-main-content">
        {/* Header Section */}
        <section className="tmw-role-header">
          <h1 className="tmw-role-title">Choose Your Journey</h1>
          <p className="tmw-role-subtitle">
            Whether you're discovering your own potential or shaping your
            organization's talent strategy, we'll guide you to the right
            experience.
          </p>
        </section>

        {/* Cards Section */}
        <section className="tmw-role-cards-container">
          {/* Individual User Card */}
          <div
            className={`tmw-role-card tmw-role-card-individual ${
              hoveredCard === "individual" ? "tmw-role-card-hover" : ""
            }`}
            onMouseEnter={() => setHoveredCard("individual")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="tmw-role-card-icon tmw-role-icon-individual">
              <FaUserCircle size={48} />
            </div>

            <h2 className="tmw-role-card-title">Individual User</h2>

            <p className="tmw-role-card-description">
              Explore your career growth through personalized assessments and AI
              insights.
            </p>

            <ul className="tmw-role-key-points">
              <li className="tmw-role-key-point">
                <span className="tmw-role-point-icon">✓</span>
                <span>
                  Comprehensive behavioral and skill-based assessments
                </span>
              </li>
              <li className="tmw-role-key-point">
                <span className="tmw-role-point-icon">✓</span>
                <span>
                  Personalized insights for self-development and career planning
                </span>
              </li>
              <li className="tmw-role-key-point">
                <span className="tmw-role-point-icon">✓</span>
                <span>
                  AI-driven recommendations to enhance your professional growth
                </span>
              </li>
            </ul>

            <button
              className={`tmw-role-btn tmw-role-individual-btn ${
                isLoading === "individual" ? "tmw-role-btn-active" : ""
              }`}
              onClick={() => handleRoleSelect("individual")}
              disabled={isLoading !== null}
            >
              {isLoading === "individual"
                ? "Redirecting..."
                : "Continue as Individual"}
            </button>
          </div>

          {/* Business User Card */}
          <div
            className={`tmw-role-card tmw-role-card-business ${
              hoveredCard === "business" ? "tmw-role-card-hover" : ""
            }`}
            onMouseEnter={() => setHoveredCard("business")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="tmw-role-card-icon tmw-role-icon-business">
              <FaBuilding size={48} />
            </div>

            <h2 className="tmw-role-card-title">Business User</h2>

            <p className="tmw-role-card-description">
              Manage workforce potential — assess, upskill, and align talent
              with organizational goals.
            </p>

            <ul className="tmw-role-key-points">
              <li className="tmw-role-key-point">
                <span className="tmw-role-point-icon">✓</span>
                <span>Comprehensive workforce analytics and insights</span>
              </li>
              <li className="tmw-role-key-point">
                <span className="tmw-role-point-icon">✓</span>
                <span>Leadership and role-fit identification</span>
              </li>
              <li className="tmw-role-key-point">
                <span className="tmw-role-point-icon">✓</span>
                <span>
                  Personalized upskilling recommendations for employees
                </span>
              </li>
            </ul>

            <button
              className={`tmw-role-btn tmw-role-business-btn ${
                isLoading === "business" ? "tmw-role-btn-active" : ""
              }`}
              onClick={() => handleRoleSelect("business")}
              disabled={isLoading !== null}
            >
              {isLoading === "business"
                ? "Redirecting..."
                : "Continue as Business"}
            </button>
          </div>
        </section>

        {/* Footer Section */}
        {/*<footer className="tmw-role-footer">
          <p className="tmw-role-footer-text">
            Not sure which is right for you?{" "}
            <a href="#" className="tmw-role-learn-more-link">
              Learn more
            </a>
          </p>
        </footer>*/}
      </main>

      {/* Business User Popup Form Modal */}
      {showBusinessPopup && (
        <div className="tmw-biz-popup-overlay">
          <div className="tmw-biz-popup-container">
            <div className="tmw-biz-popup-header">
              <h2 className="tmw-biz-popup-title">Business Information</h2>
              <button
                className="tmw-biz-popup-close"
                onClick={handleClosePopup}
                aria-label="Close popup"
              >
                ×
              </button>
            </div>

            <form
              className="tmw-biz-popup-form"
              onSubmit={handleBusinessFormSubmit}
            >
              <div className="tmw-biz-form-group">
                <label className="tmw-biz-form-label" htmlFor="organization">
                  Organization <span className="tmw-biz-required">*</span>
                </label>
                <input
                  type="text"
                  id="organization"
                  name="organization"
                  value={businessFormData.organization}
                  onChange={handleBusinessFormChange}
                  placeholder="Enter your organization name"
                  className={`tmw-biz-form-input ${
                    businessFormErrors.organization
                      ? "tmw-biz-form-input-error"
                      : ""
                  }`}
                />
                {businessFormErrors.organization && (
                  <span className="tmw-biz-form-error">
                    {businessFormErrors.organization}
                  </span>
                )}
              </div>

              <div className="tmw-biz-form-group">
                <label className="tmw-biz-form-label" htmlFor="website">
                  Website <span className="tmw-biz-required">*</span>
                </label>
                <input
                  type="text"
                  id="website"
                  name="website"
                  value={businessFormData.website}
                  onChange={handleBusinessFormChange}
                  placeholder="Enter your website URL"
                  className={`tmw-biz-form-input ${
                    businessFormErrors.website ? "tmw-biz-form-input-error" : ""
                  }`}
                />
                {businessFormErrors.website && (
                  <span className="tmw-biz-form-error">
                    {businessFormErrors.website}
                  </span>
                )}
              </div>

              {/* <div className="tmw-biz-form-group">
                <label className="tmw-biz-form-label" htmlFor="industry">
                  Industry <span className="tmw-biz-required">*</span>
                </label>
                <select
                  id="industry"
                  name="industry"
                  value={businessFormData.industry}
                  onChange={handleBusinessFormChange}
                  //   className={`tmw-biz-form-input ${
                  //     businessFormErrors.industry
                  //       ? "tmw-biz-form-input-error"
                  //       : ""
                  //   }`}
                  className={`tmw-biz-form-input ${
                    businessFormErrors.industry
                      ? "tmw-biz-form-input-error"
                      : ""
                  } tmw-biz-form-input--with-icon`}
                >
                  <option value="">Select your industry</option>
                  {industries?.map((industry) => (
                    <option key={industry} value={industry}>
                      {industry}
                    </option>
                  ))}
                </select>
                {businessFormErrors.industry && (
                  <span className="tmw-biz-form-error">
                    {businessFormErrors.industry}
                  </span>
                )}
              </div> */}

              <div className="tmw-biz-popup-actions">
                <button
                  type="button"
                  className="tmw-biz-btn-cancel"
                  onClick={handleClosePopup}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={`tmw-biz-btn-submit ${
                    isLoading === "business" ? "tmw-biz-btn-submitting" : ""
                  }`}
                  disabled={isLoading === "business"}
                >
                  {isLoading === "business"
                    ? "Submitting..."
                    : "Continue as Business"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
